import { Action } from '@ngrx/store';

export enum PrivacyAndTermsActionTypes {
  LoadPrivacyAndTermss = '[PrivacyAndTerms] Load PrivacyAndTermss',
  GetPrivacyAndTerms = '[PrivacyAndTerms] Get PrivacyAndTermss',
  GetPrivacyAndTermsFail = '[PrivacyAndTerms] Get PrivacyAndTermss Fail',
}

export class GetPrivacyAndTerms implements Action {
  readonly type = PrivacyAndTermsActionTypes.GetPrivacyAndTerms;
}

export class LoadPrivacyAndTermss implements Action {
  readonly type = PrivacyAndTermsActionTypes.LoadPrivacyAndTermss;
  constructor(public payload: {privacy: string, terms: string}) {}
}

export class GetPrivacyAndTermsFails implements Action {
  readonly type = PrivacyAndTermsActionTypes.GetPrivacyAndTermsFail;
}


export type PrivacyAndTermsActions = LoadPrivacyAndTermss
  | GetPrivacyAndTerms
  | GetPrivacyAndTermsFails;
